import { Controller } from "react-hook-form";

import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

const ControlledRadioGroup = ({
	control,
	name,
	label,
	options,
	className,
	disabled,
	defaultValue,
}) => {
	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field }) => (
				<RadioGroup
					name={name}
					row
					aria-labelledby={label}
					className={className}
					{...field}
					value={field.value || "notExisting"}
				>
					{options.map((option) => (
						<FormControlLabel
							disabled={disabled}
							key={option.value}
							value={option.value}
							control={<Radio />}
							label={option.label}
						/>
					))}
				</RadioGroup>
			)}
		/>
	);
};

export default ControlledRadioGroup;
